const icons = {
  PROTECT_EMAILS: (
    <>
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3" />
      <circle cx="12" cy="11" r="1" />
      <line x1="12" y1="12" x2="12" y2="14.5" />
    </>
  ),
  REPLACE_ATTACHMENTS: (
    <>
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M4 12v-3a3 3 0 0 1 3 -3h13m-3 -3l3 3l-3 3" />
      <path d="M20 12v3a3 3 0 0 1 -3 3h-13m3 3l-3 -3l3 -3" />
    </>
  ),
  DRAG_AND_DROP: (
    <>
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M19 11v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2" />
      <path d="M13 13l9 3l-4 2l-2 4l-3 -9" />
      <line x1="3" y1="3" x2="3" y2="3.01" />
      <line x1="7" y1="3" x2="7" y2="3.01" />
      <line x1="11" y1="3" x2="11" y2="3.01" />
      <line x1="15" y1="3" x2="15" y2="3.01" />
      <line x1="3" y1="7" x2="3" y2="7.01" />
      <line x1="3" y1="11" x2="3" y2="11.01" />
      <line x1="3" y1="15" x2="3" y2="15.01" />
    </>
  ),
};

export const ActionIcon = ({ type }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="MuiSvgIcon-root MuiSvgIcon-fontSizeLarge"
      width="1em"
      height="1em"
      fontSize="inherit"
      viewBox="0 0 24 24"
      strokeWidth="1.75"
      style={{ stroke: "currentColor", fill: "none" }}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {icons[type]}
    </svg>
  );
};

export const SendDelayIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M13 19h-8a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6" />
    <path d="M3 7l9 6l9 -6" />
    <path d="M17 17v5" />
    <path d="M21 17v5" />
  </svg>
);

export const ZipAttachmentsIcon = () => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-width="1.8"
      d="M10 3v4a1 1 0 0 1-1 1H5m14-4v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1Zm-4 1h.01v.01H15V5Zm-2 2h.01v.01H13V7Zm2 2h.01v.01H15V9Zm-2 2h.01v.01H13V11Zm2 2h.01v.01H15V13Zm-2 2h.01v.01H13V15Zm2 2h.01v.01H15V17Zm-2 2h.01v.01H13V19Z"
    />
  </svg>
);

export const SmimeIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
  >
    <g transform="translate(0,512) scale(0.1,-0.1)">
      <path d="M159 4626 c-65 -17 -104 -49 -133 -108 l-26 -52 0 -1625 0 -1626 24 -52 c28 -59 76 -96 146 -112 30 -7 579 -11 1613 -11 l1568 0 -7 -22 c-4 -12 -29 -67 -55 -122 -52 -106 -58 -138 -33 -174 27 -39 57 -44 158 -27 50 8 101 18 113 20 19 4 30 -8 78 -89 66 -110 92 -137 133 -138 57 -2 73 20 177 242 55 116 102 213 106 215 3 3 50 -89 104 -203 54 -114 108 -218 120 -230 16 -17 34 -24 59 -24 44 0 66 17 103 81 14 25 41 69 59 97 l32 51 116 -19 c134 -21 163 -14 186 42 15 35 13 40 -63 203 l-46 97 107 0 c184 1 255 30 298 124 l24 53 -2 1635 -3 1635 -30 48 c-21 35 -45 56 -80 74 l-49 26 -2376 2 c-1858 1 -2385 -1 -2421 -11z m4768 -147 c15 -5 31 -16 35 -22 10 -16 10 -3218 0 -3234 -16 -24 -68 -33 -202 -33 l-140 0 -21 42 c-20 40 -20 41 -2 51 10 5 39 31 65 58 52 53 78 119 78 201 0 34 9 65 33 110 45 87 45 166 -1 260 -21 44 -32 82 -32 111 0 106 -50 193 -149 256 -26 17 -57 48 -69 70 -27 48 -93 108 -139 128 -20 8 -68 17 -107 20 -51 4 -87 14 -128 36 -80 42 -162 41 -250 0 -42 -20 -86 -32 -133 -36 -94 -9 -166 -45 -208 -104 -41 -59 -93 -111 -145 -145 -61 -40 -92 -101 -101 -200 -6 -62 -15 -97 -37 -138 -25 -47 -29 -67 -29 -130 0 -65 4 -83 33 -137 24 -48 32 -75 32 -116 0 -94 42 -176 114 -224 l42 -28 -18 -43 -19 -42 -1604 0 c-1108 0 -1612 3 -1632 11 -15 5 -31 16 -35 22 -10 16 -10 3218 0 3234 4 7 19 16 32 22 36 14 4699 15 4737 0z m-801 -2103 c35 -17 68 -26 100 -26 82 0 121 -16 154 -63 55 -80 72 -98 126 -132 65 -42 84 -76 84 -151 0 -43 8 -75 35 -134 19 -43 35 -83 35 -90 0 -7 -16 -47 -35 -90 -27 -59 -35 -91 -35 -134 0 -72 -19 -109 -73 -142 -60 -38 -85 -62 -123 -121 -18 -28 -41 -56 -51 -61 -10 -5 -52 -12 -93 -15 -55 -5 -89 -14 -132 -37 -73 -38 -113 -38 -188 0 -42 21 -80 32 -132 36 -89 8 -109 20 -154 89 -22 35 -55 69 -94 95 -33 22 -66 51 -74 63 -8 12 -16 55 -19 95 -3 56 -12 87 -36 133 -39 74 -39 104 0 178 24 45 32 77 38 139 8 91 21 112 98 157 26 16 59 49 83 85 23 33 51 67 65 76 13 8 59 19 102 23 48 5 95 17 123 31 86 44 103 44 196 -4z m-525 -1252 c24 -29 70 -45 157 -55 48 -5 97 -16 109 -25 27 -17 31 -5 -67 -207 -33 -70 -65 -125 -70 -122 -5 3 -22 29 -39 58 -16 29 -41 63 -55 76 -23 22 -31 23 -95 17 -38 -3 -76 -9 -85 -12 -9 -3 -16 -2 -16 3 0 18 130 283 139 283 5 0 14 -7 22 -16z m942 -126 c37 -77 66 -142 65 -143 -2 -1 -38 3 -80 8 -101 13 -116 6 -168 -82 -23 -39 -44 -71 -47 -71 -6 0 -153 306 -153 318 0 16 51 32 130 41 70 8 150 37 165 61 3 5 10 10 14 10 4 0 38 -64 74 -142z" />
      <path d="M751 4232 c-20 -19 -30 -43 -35 -77 -10 -67 -27 -104 -67 -149 -48 -55 -100 -84 -176 -100 -50 -11 -74 -22 -90 -41 l-23 -26 0 -1000 0 -1001 28 -28 c18 -18 44 -30 73 -35 137 -22 225 -106 253 -242 11 -50 22 -74 41 -90 l26 -23 1133 0 c1131 0 1133 0 1160 21 34 27 35 71 1 104 l-24 25 -1095 0 -1094 0 -7 32 c-10 45 -51 124 -88 171 -42 51 -137 114 -203 133 l-54 15 0 918 0 918 43 13 c146 43 272 172 302 308 l7 32 1688 0 1688 0 17 -52 c46 -144 167 -259 303 -289 l52 -12 0 -647 c0 -640 0 -648 21 -674 15 -19 30 -26 54 -26 24 0 39 7 54 26 21 26 21 34 21 715 l0 688 -23 26 c-17 20 -39 30 -94 40 -39 8 -88 23 -110 33 -78 41 -134 124 -148 225 -6 35 -15 54 -37 72 l-30 25 -1770 0 -1770 0 -27 -28z" />
      <path d="M1056 3729 c-34 -27 -36 -77 -3 -107 l23 -22 1485 0 1486 0 21 23 c31 33 29 80 -4 106 l-27 21 -1477 0 -1477 0 -27 -21z" />
      <path d="M1052 3317 c-28 -30 -29 -78 -1 -103 19 -17 41 -19 232 -22 226 -3 256 1 276 44 16 37 14 52 -14 79 l-24 25 -224 0 c-221 0 -224 0 -245 -23z" />
      <path d="M1792 3317 c-27 -29 -28 -67 -3 -98 l19 -24 1120 0 c1087 0 1121 1 1141 19 29 26 28 76 -2 104 l-23 22 -1115 0 -1116 0 -21 -23z" />
      <path d="M1052 2907 c-31 -33 -29 -80 4 -106 l27 -21 1477 0 1477 0 27 21 c34 27 36 77 3 107 l-23 22 -1485 0 -1486 0 -21 -23z" />
      <path d="M2022 2393 c-7 -3 -19 -17 -27 -33 -19 -36 -4 -83 31 -99 18 -8 175 -11 534 -11 359 0 516 3 534 11 35 16 50 63 31 99 -8 15 -22 30 -30 34 -20 7 -1054 7 -1073 -1z" />
      <path d="M3945 2239 c-244 -35 -421 -277 -385 -526 45 -320 402 -494 688 -335 142 79 232 236 232 404 0 284 -250 498 -535 457z m212 -180 c188 -90 233 -344 87 -494 -130 -135 -340 -130 -463 11 -54 61 -74 118 -74 204 0 152 97 275 243 307 73 16 132 8 207 -28z" />
    </g>
  </svg>
);
